<ng-container [ngSwitch]="type">
    <h3 *ngSwitchCase="'h3'">{{ title }}</h3>
    <h5 *ngSwitchCase="'h5'">{{ title }}</h5>
    <p *ngSwitchDefault>Invalid heading type. Please use 'h3' or 'h5'.</p>
  </ng-container>